import React from "react";
import { Card, CardBody, Button } from "reactstrap";
import FeatherIcon from "feather-icons-react";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const ResponseActions = () => {
  return (
    <Card className="shadow-sm border mt-4" style={cardShell}>
      <CardBody className="p-4">
        <h5 className="fw-bold mb-4">Response Actions</h5>

        <Button
          className="w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
          style={{
            backgroundColor: "#0000",
            color: "#FF5B00",
            padding: "12px",
            fontSize: "15px",
            fontWeight: "500",
            border:"1px solid #FF5B00"
          }}
        >
          <FeatherIcon icon="shield" size={18} />
          Isolate Host
        </Button>

        <Button
          color="light"
          className="w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
          style={{
            padding: "12px",
            fontSize: "15px",
            fontWeight: "500",
            border: "1px solid #dee2e6",
          }}
        >
          <FeatherIcon icon="user" size={18} />
          Reassign
        </Button>

        <Button
          color="light"
          className="w-100 mb-4 d-flex align-items-center justify-content-center gap-2"
          style={{
            padding: "12px",
            fontSize: "15px",
            fontWeight: "500",
            border: "1px solid #dee2e6",
          }}
        >
          <FeatherIcon icon="message-square" size={18} />
          Comment
        </Button>

        <hr style={{ margin: "20px 0", borderColor: "#dee2e6" }} />

        <div className="d-flex gap-2">
          <Button
            className="flex-grow-1 d-flex align-items-center justify-content-center gap-2 btn btn-outline-warning"
            style={{
              backgroundColor: "#0000",
              color: "#43a12bff",
              padding: "10px",
              fontSize: "14px",
              fontWeight: "500",
              border:"1px solid #43a12bff"
            }}
          >
            <FeatherIcon icon="check" size={16} />
            Resolved
          </Button>

          <Button
            color="light"
            className="flex-grow-1 d-flex align-items-center justify-content-center gap-2"
            style={{
              padding: "10px",
              fontSize: "14px",
              fontWeight: "500",
              border: "1px solid #dee2e6",
            }}
          >
            <FeatherIcon icon="arrow-up" />
            Escalated
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default ResponseActions;
